var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.$t(("list.statuses." + (_vm.shipment.status))))+" ")]),_vm._v("\n  /\n  "+_vm._s(_vm.$t(("list.steps." + (_vm.shipment.step))))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }